import * as theme from "lib/styles/theme";
import React from "react";

const BASE_WIDTH = 22;
const BASE_HEIGHT = 21;
const BASE_COLOR_OFF = theme.colors.textAndShapes.InputDisabledLabelText;
const BASE_COLOR_ON = theme.colors.brand.Branding;

interface OwnProps {
  height?: number;
  width?: number;
  enabled?: boolean;
  onColor?: string;
  offColor?: string;
}

export default function HeartSmallIcon(props: OwnProps) {
  const { enabled, onColor, offColor } = props;
  const width = props.width || BASE_WIDTH;
  const height = props.height || BASE_HEIGHT;
  const formattedColor = enabled
    ? onColor ?? BASE_COLOR_ON
    : offColor ?? BASE_COLOR_OFF;

  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21 3.59248C20.1067 1.75915 17.5333 0.259152 14.54 1.13249C13.1096 1.54564 11.8617 2.43167 11 3.64582C10.1383 2.43167 8.89036 1.54564 7.46 1.13249C4.46 0.272485 1.89333 1.75915 1 3.59248C-0.253332 6.15915 0.266668 9.04582 2.54667 12.1725C4.33334 14.6192 6.88667 17.0992 10.5933 19.9792C10.7105 20.0705 10.8548 20.1201 11.0033 20.1201C11.1519 20.1201 11.2962 20.0705 11.4133 19.9792C15.1133 17.1058 17.6733 14.6458 19.46 12.1725C21.7333 9.04582 22.2533 6.15915 21 3.59248Z"
        fill={formattedColor}
      />
    </svg>
  );
}
